import React from "react";
import Events from "../../components/events/Events";

const EventsPage = () => {
  return (
    <>
      <Events />
    </>
  );
};

export default EventsPage;
